import profilePhoto from "@/assets/developerDark-nobg.png";

export const SITE = {
  name: "NanthaGopal G",
  shortName: "Nanthu",
  title: "Front-End Developer",
  email: "nanthugopal@example.com",
  location: "Bengaluru, India",
  phone: "+91 9876543210",
  tagline: "WEB DESIGNER",
  profilePhoto,
};

export const NAV_ITEMS = [
  { label: "Home", id: "home" },
  { label: "About", id: "about" },
  { label: "Services", id: "features" },
  { label: "Project", id: "portfolio" },
  { label: "Contact", id: "contact" },
];

export const SOCIAL_LINKS = [
  { icon: "mdi-instagram", label: "Instagram", url: "https://instagram.com" },
  { icon: "mdi-linkedin", label: "LinkedIn", url: "https://linkedin.com" },
  { icon: "mdi-twitter", label: "Twitter", url: "https://twitter.com" },
  { icon: "mdi-facebook", label: "Facebook", url: "https://facebook.com" },
];

export const TYPEWRITER_WORDS = [
  "Front-End Developer.",
  "Vue.js Specialist.",
  "UI Engineer.",
];

export const SERVICE_CARDS = [
  { icon: "mdi-palette-outline", title: "Web Design", count: "50 Projects" },
  { icon: "mdi-cellphone", title: "App Development", count: "30 Projects" },
  { icon: "mdi-chart-line", title: "Digital Marketing", count: "15 Projects" },
  { icon: "mdi-camera-outline", title: "Photography", count: "25 Projects" },
];

export const STATS = [
  { value: "50+", label: "Projects Complete" },
  { value: "20+", label: "Happy Clients" },
  { value: "4+", label: "Years Experience" },
  { value: "100+", label: "Client Reviews" },
];

export const DESIGN_SKILLS = [
  { name: "UI Design", value: 95 },
  { name: "Figma", value: 90 },
  { name: "Responsive Design", value: 100 },
  { name: "Prototyping", value: 85 },
];

export const DEV_SKILLS = [
  { name: "Vue.js", value: 100 },
  { name: "JavaScript", value: 95 },
  { name: "HTML / CSS", value: 100 },
  { name: "Vuetify", value: 90 },
];

export const ABOUT_CARDS = [
  {
    number: "01",
    title: "A Portfolio of Creativity",
    description:
      "Crafting visually stunning and user-centric interfaces that leave lasting impressions and drive engagement.",
  },
  {
    number: "02",
    title: "My Portfolio of Innovation",
    description:
      "Building scalable front-end architectures with Vue.js that power enterprise-grade web applications.",
  },
  {
    number: "03",
    title: "A Showcase of My Projects",
    description:
      "Delivering high-performance SPAs with clean code, seamless API integration, and pixel-perfect execution.",
  },
];

export const FOOTER_LINKS = [
  { label: "About Me", id: "about" },
  { label: "Services", id: "features" },
  { label: "Contact Me", id: "contact" },
  { label: "Projects", id: "portfolio" },
  { label: "Resume", id: "resume" },
];
